export default __webpack_public_path__ + "static/18-c4bf69456f97538dc4b438be31e6727d.webp";